import { Trans } from '@lingui/react'

// @ts-ignore
const RedPointsLabel = ({ redPoints }) =>
  Boolean(redPoints) && (
    <span
      className="u-color--red o-ProductInfo__red-points"
      data-qa-id="cart-entry-RedPoints"
    >
      +{' '}
      <Trans
        id="general.label.product.redPoints"
        values={{
          redPoints,
        }}
      />
    </span>
  )

export default RedPointsLabel
